'use client';
import React from 'react';
import { Card, Heading, ImageUploader } from '@ui';
import { withOptionalId } from '@lib/withOptionalId';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface FileUploaderImageDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const FileUploaderImageDemo: React.FC<FileUploaderImageDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as="h3">{t('File Uploader (Images)', 'Subidor de archivos (Imágenes)')}</Heading>
        <p className='sub full'>
          {t(
            'Drag & drop or browse. Shows live thumbnails with remove & size checks.',
            'Arrastra y suelta o busca. Muestra miniaturas en vivo con opciones de quitar y validaciones de tamaño.'
          )}
        </p>

        <Card id='uploadCard'>
          <ImageUploader id='demoImageUploader' />
        </Card>
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="card dropzone">
  <div class="dropzone-inner">Drop an image</div>
  <input type="file" accept="image/*" />
</div>`}
        />
      </Container>
    </Section>
  );
};

export default FileUploaderImageDemo;
